// extracted by mini-css-extract-plugin
export default {"category":"Category_category__yz+7n","category__container":"Category_category__container__jYxj9"};